var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.updateExists)?_c('div',{staticClass:"changes-update-btn-wrap"},[_c('button',{staticClass:"changes-update-btn",on:{"click":_vm.refreshApp}},[_vm._v("New version available! Click to update")])]):_vm._e(),_c('div',{staticClass:"list-view"},[_c('router-view')],1),_c('div',{staticClass:"bottom-spacer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }